import { accessToken, currentAccountId } from '../authentication'

import { VERSION } from '../version'

import useFetch from './useFetch'

// TODO: HARVEST_HOST should be an actual host, not a partial URL
const HARVESTAPP_HOST = import.meta.env.VITE_HARVESTAPP_V2_API_URL
// TODO: HARVESTID_HOST should be an actual host, not a partial URL
const HARVESTID_HOST = import.meta.env.VITE_HARVEST_ID_V2_API_URL

const SCHEME = import.meta.env.VITE_SCHEME

const DEFAULT_HEADERS = {
  Accept: 'application/json',
  Authorization: `Bearer ${accessToken}`,
  'X-Harvest-Platform-Version': VERSION,
}

const HARVESTAPP_HEADERS = Object.assign(
  { ...DEFAULT_HEADERS },
  {
    'Harvest-Account-Id': currentAccountId,
  }
)

export function useFetchFromHarvestApp(path) {
  return useFetch(SCHEME + '://' + HARVESTAPP_HOST + path, HARVESTAPP_HEADERS)
}

export function useFetchFromHarvestId(path) {
  return useFetch(SCHEME + '://' + HARVESTID_HOST + path, DEFAULT_HEADERS)
}
